define('views/modules/calendar/activity/detail/blocks/calories-burn',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/info-section',
    'views/parts/form/textbox',
    // templates
    'text!templates/modules/calendar/activity/detail/blocks/calories-burn.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VInfoSection,
    VTextbox,
    // templates
    TCaloriesBurn
) {

    var VCaloriesBurn = Backbone.View.extend({
        template: TCaloriesBurn,

        regions: {
            calories: ".calories-input"
        },

        initialize: function() {
            this.view = {
                info: new VInfoSection({
                    content: this.template,
                }),
                calories: new VTextbox({
                    model: this.model,
                    attribute: 'calories',
                    labelposition: 'top',
                    label: 'calendar:How many calories did you burn?',
                    help: 'calendar:You can overwrite automatic calculation',
                    addon: true,
                    addonBefore: '<span class="sl-icon-fire"></span>',
                    addonAfter: "Cal."
                }),
            };
        },

        render: function() {
            // Insert Info Section rendered inside this view
            var view = this.view;
            this.assign(view.info, this.$el);

            // Caching scoped jquery element from 'regions'.
            this.generateZones();
            var zone = this.zone;

            // Assign Views
            this.assign(view.calories, zone.$calories);

            return this;
        },

    });

    return VCaloriesBurn;

});

